import { useEffect, useRef } from 'react';

import { useFeatureFlagEnabled } from '@posthog/react';

import OutlookReminderModal from '@/components/common/OutlookReminderModal';
import { useModal } from '@/components/providers/ModalProvider/ModalProvider';
import useEmailClient from '@/features/email/hooks/useEmailClient';
import useOutlookConnection from '@/features/settings/queries/hooks/useOutlookConnection';

import useAuth from './useAuth';

export default function useOutlookReminder() {
  const isOutlookSSOEnabled = useFeatureFlagEnabled('outlook-sso');
  const isOutlookMandatory = useFeatureFlagEnabled('outlook-sso-mandatory');
  const { showModal } = useModal();
  const { broker } = useAuth();

  const hasShownReminderRef = useRef<boolean>(false);

  const { data: outlook, isPending } = useOutlookConnection();

  const { mode } = useEmailClient();

  useEffect(() => {
    if (
      isPending ||
      outlook?.connected ||
      !isOutlookSSOEnabled ||
      !broker ||
      mode === 'Compose' ||
      isOutlookMandatory
    )
      return;

    if (hasShownReminderRef.current) return;

    hasShownReminderRef.current = true;

    showModal(OutlookReminderModal);
  }, [
    broker,
    hasShownReminderRef,
    isPending,
    isOutlookMandatory,
    isOutlookSSOEnabled,
    mode,
    outlook,
    showModal,
  ]);
}
